<template>
  <div
    :class="props.from === 'course-detail' ? 'nav nav-white' : 'nav nav-black'"
  >
    <div class="inner">
      <!-- <img
        class="logo"
        :src="
          props.from === 'course-detail'
            ? require('@/assets/home_image/logo2.png')
            : require('@/assets/home_image/logo1.png')
        "
        @click="gotoTop"
        alt=""
      /> -->
      <span
        ><img
          :src="
            props.from === 'course-detail'
              ? require('@/assets/logo.png')
              : require('@/assets/logo1.png')
          "
          alt=""
        />北京声乐学院</span
      >
      <div class="list-box">
        <div
          v-for="item in navOption"
          :key="item.id"
          @click="gotoPage(item.route)"
          :class="
            item.name == route.name
              ? `item item-${item.id} active`
              : `item item-${item.id}`
          "
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
import { useRoute, useRouter } from "vue-router";
const thieRoute = ref("/");
const props = defineProps(["from"]);
const route = useRoute();
const router = useRouter();
console.log(route);
const navOption = [
  {
    id: "1",
    label: "首页",
    route: "/",
    name: "home",
  },
  {
    id: "2",
    label: "业务板块",
    route: "/courseCenter",
    name: "courseCenter",
  },
  {
    id: "3",
    label: "音乐剧介绍",
    route: "/musicalIntroductionCenter",
    name: "musicalIntroductionCenter",
  },
  {
    id: "4",
    label: "关于我们",
    route: "/aboutUs",
    name: "aboutUs",
  },
];
const gotoPage = (route) => {
  // window.location.href = route;
  router.replace(route);
};
const gotoTop = () => {
  window.scrollTop = 0;
};
</script>
<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 80px;
  z-index: 101;
  transition: all 0.3s;
  .inner {
    width: 1200px !important;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 32px;
      // font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      letter-spacing: 5px;
      > img {
        width: 50px;
        margin-right: 10px;
      }
    }
    .logo {
      display: block;
      width: 192px;
      cursor: pointer;
    }
    .list-box {
      display: flex;
      align-items: center;
      //   .item {
      //     // color: #000;
      //   }
      //   .item.active {
      //     // border-bottom: 1px solid red;
      //   }
      .item-1 {
        width: 90px;
        height: 40px;
      }
      .item-1.active {
        background-image: url("~@/assets/home_image/background_image/nav_active.png");
      }
      .item-2,
      .item-3,.item-4 {
        width: 113px;
        height: 40px;
      }
      .item-2.active,
      .item-3.active,.item-4.active {
        background-image: url("~@/assets/home_image/background_image/nav_active2.png");
      }
    }
  }
}
.nav-black {
  background: linear-gradient(180deg, #000, transparent);

  .item {
    font-size: 16px;
    color: #fdfdfe;
    margin: 0 30px;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
    text-indent: 1em;
  }
}
.nav-white {
  background: #fff;
  .inner {
    span {
      color: #000;
    }
  }
  .item {
    font-size: 16px;
    color: #000;
    margin: 0 30px;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
    text-indent: 1em;
  }
}
.nav.nav-active {
  background: #fff;
  border: 0;
  box-shadow: 0 1px 5px 0 #ddd;
}
</style>
